import { useEffect, useMemo, useRef, useState } from 'react';
import '@adyen/adyen-web/dist/adyen.css';
import {
  CardElementData,
  CardElementProps,
} from '@adyen/adyen-web/dist/types/components/Card/types';
import CardElement from '@adyen/adyen-web/dist/types/components/Card';
import UIElement from '@adyen/adyen-web/dist/types/components/UIElement';
import AdyenCore from '@adyen/adyen-web/dist/types/core';

interface CardState {
  isValid: boolean;
  data: CardElementData;
}

export default function CardEntry({
  setCardData,
  adyenSdk,
}: {
  setCardData: (data: CardElementData) => void;
  adyenSdk: AdyenCore;
}): JSX.Element {
  const cardContainer = useRef<HTMLDivElement>(null);
  const [card, setCard] = useState<CardElement | null>(null);
  const configuration: CardElementProps = useMemo(() => {
    const handleOnChange = (state: CardState, component: UIElement) => {
      setCard(component as CardElement);
      if (state?.isValid && state?.data) {
        setCardData(state.data);
      }
      //    state.isValid // True or false. Specifies if all the information that the shopper provided is valid.
      //    state.data // Provides the data that you need to pass in the `/payments` call.
      //    component // Provides the active component instance that called this event.
    };

    const handleOnAdditionalDetails = (state: CardState, component: UIElement) => {
      setCard(component as CardElement);
      //    state.data // Provides the data that you need to pass in the `/payments/details` call.
      //    component // Provides the active component instance that called this event.
    };
    return {
      type: 'card',
      brands: ['mc', 'visa'],
      useClickToPay: false,
      onChange: handleOnChange, // Your function for handling onChange event
      onAdditionalDetails: handleOnAdditionalDetails, // Your function for handling onAdditionalDetails event
    };
  }, [setCardData, setCard]);

  useEffect(() => {
    if (cardContainer?.current != null && card == null) {
      setCard(adyenSdk.create('card', configuration).mount(cardContainer.current));
    }
  }, [card, configuration, adyenSdk]);
  return <div id="card-container" ref={cardContainer}></div>;
}
